import React from "react";
import "./App.css";

function Footer() {
  return (
    <div>
      <p class="footer-text">
        <a
          class="link-footer"
          href="https://github.com/Kristina-YA/weather-app-react"
        >
          Open-source code
        </a>
        <span> by Krystyna Y</span>
      </p>
    </div>
  );
}
export default Footer;
